<template>
    <div class="px-1 mx-2 lg:ml-5">
        <a href="#" class="leading-loose text-gray-900">English <span class="icon-chevron-down ml-1"></span></a>
    </div>
</template>

<script>
    export default {
        name: "HeaderLang"
    }
</script>

<style scoped>

</style>